import * as React from "react";
import Integration from "./components/integration/integration";
import { IntegrationsData } from "./integrations-data";
import "./integrations.scss";

class Integrations extends React.Component<{}, {}> {
  public render() {
    return (
      <div className="integrations">
        {IntegrationsData.map(integration => (
          <Integration
            key={integration.id}
            image={integration.image}
            alt={integration.alt}
          />
        ))}
      </div>
    );
  }
}

export default Integrations;



// WEBPACK FOOTER //
// ./src/components/integrations/integrations.tsx